const displayDateOptions = {
  month: "short",
  day: "numeric",
  year: "numeric"
};
export const formatDate = (date, options = displayDateOptions) => {
  const displayDate = new Date(date);
  return displayDate.toLocaleDateString("en-us", options);
};
export const formatTime = (date, options) => {
  const displayTime = new Date(date);
  return displayTime.toLocaleTimeString("en-us", options);
};
export const padZeros = time => {
  return time.length === 1 ? `0${time}` : time;
};